'use client'

import { motion, AnimatePresence as MotionAnimatePresence } from 'motion/react'

type FadeProps = {
  children: React.ReactNode
  duration?: number
  className?: string
}

const Fade = ({ children, duration = 0.2, className }: FadeProps) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration, ease: 'easeInOut' }}
    className={className}
  >
    {children}
  </motion.div>
)

type AnimateProps = {
  children?: React.ReactElement<typeof Fade> | null | false
}

export const AnimatePresence = ({ children }: AnimateProps) => (
  <MotionAnimatePresence mode="wait" initial={false}>
    {children}
  </MotionAnimatePresence>
)

AnimatePresence.Fade = Fade
